import { axiosInstance } from "../../../helper"
import { video } from "../types"

export function updateVideo(id, data, config) {
	return {
		type: video.UPDATE_VIDEO,
		payload: new axiosInstance.put(
			`/admin/streaming-video/${id}`,
			data,
			config
		),
	}
}

export default updateVideo
